module.exports = __webpack_public_path__ + "static/media/fal.b0deb9f5.ogg";